import { render, staticRenderFns } from "./StrdPD_Items.vue?vue&type=template&id=ff46b390"
import script from "./StrdPD_Items.vue?vue&type=script&lang=js"
export * from "./StrdPD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports